import { FormControl } from '@angular/forms';

export class EmailAddressValidator {
  static singleAddress(fc: FormControl) {
    if (!fc.value || typeof fc.value !== 'string') {
      return null;
    }
    if (fc.value.indexOf(',') >= 0) {
      return { singleAddress: true };
    }
    return null;
  }
}
